import axios from "axios";

const API_ADMIN = `${process.env.REACT_APP_API_URL}/api/admin`;
const API_GESTIONNAIRE = `${process.env.REACT_APP_API_URL}/api/gestionnaire`;

export default class ContactService {

    static getApiUrl(role) {
        return role === "admin" ? API_ADMIN : API_GESTIONNAIRE;
    }

    static async sendMessage(userRole, data) {
        const token = localStorage.getItem("token");
        const apiUrl = this.getApiUrl(userRole);

        const payload = {
            name: data.name,
            email: data.email,
            type: data.type,
            message: data.message,
            societe_nom: data.societe_nom || null  
        };

        console.log("Payload envoyé :", payload); 

        try {
            const response = await axios.post(`${apiUrl}/contact`, payload, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
            });
            return response.data;
        } catch (error) {
            console.error("Erreur envoi contact :", error.response?.data || error);
            throw error.response?.data || error;
        }
    }
};
